import { Controller } from "@hotwired/stimulus"
import Choices from 'choices.js'

type Choice = {
  value: string
  label: string
}

// Connects to data-controller="choices"
export default class extends Controller<HTMLElement> {
  static values = {
    choices: Array<Choice>
  }

  declare choicesValue: Array<Choice>

  connect() {
    new Choices(this.element, {
      allowHTML: true,
      removeItemButton: true,
    })
  }
}